import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2464_63803)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.01363 9.1473L10.8001 15.9336C10.957 16.0907 11.1666 16.1772 11.39 16.1772C11.6134 16.1772 11.8229 16.0907 11.9799 15.9336L12.4797 15.434C12.8049 15.1084 12.8049 14.5792 12.4797 14.2541L6.78092 8.55541L12.486 2.85034C12.643 2.69326 12.7296 2.48385 12.7296 2.26056C12.7296 2.03701 12.643 1.82761 12.486 1.6704L11.9862 1.17087C11.8291 1.01379 11.6197 0.927246 11.3963 0.927246C11.1729 0.927246 10.9634 1.01379 10.8064 1.17087L4.01363 7.96339C3.85629 8.12097 3.76988 8.33137 3.77037 8.55503C3.76988 8.77957 3.85629 8.98984 4.01363 9.1473Z",
    fill: "white"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2464_63803" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "15.25",
      height: "15.25",
      fill: "white",
      transform: "translate(15.875 16.1772) rotate(-180)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }